/** «Волшебная стрела (Magic Missile)» — оригинал в скобках, если он есть и отличается */
export function withOriginal(title: string, originalTitle?: string | null): string {
	const original = originalTitle?.trim();
	return original && original.toLowerCase() !== title.trim().toLowerCase() ? `${title} (${original})` : title;
}

/** «Волшебная стрела (Magic Missile) — заклинание» */
export function entityTitle(title: string, originalTitle: string | null | undefined, kind: string): string {
	return `${withOriginal(title, originalTitle)} — ${kind}`;
}

/** Составные заголовки: «Подклассы (Коллегии) барда» */
export function pageTitle(text: string): string {
	return text;
}
